//import './css/bootstrap.min.css'; // Importation de Bootstrap
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import Pageaccueil from './pages/Home/pageaccueil';
import Accueildcca from './pages/Acceuil/accueildcca';
import Dcca from './pages/Home/dcca';
import PageEtatMajor from './pages/ETAT_MAJOR/etatmajor';
import CreactPost from './pages/CreactPost';
import Directeur from './pages/Directeur';
import CreatDirecteur from './pages/CreatDirecteur';
import EffectifNouriOrganique from './pages/EffectifNouriOrganique';
import EffectifNouriOperationnel from './pages/EffectifNouriOperationnel';

import PageNotFound from './pages/PageNotFound';
import Post from './pages/Post';
import Login from './pages/Login';
import Users from './pages/User';
import CreatUsers from './pages/CreatUsers';
import EditUser from './pages/EditUser';
import EditDirecteur from './pages/EditDirecteur';

import { useContext, useEffect, useState } from 'react';
import Books from './pages/Books';
import CreatBooks from './pages/CreatBooks';
import ListeBoaDss from './pages/ListeBoaDss';
import Statistics from './pages/Statistics';
import CreatDecoration from './pages/CreatDecoration';
import SearchForm from './pages/SearchForm';
import Categorie from './pages/Categorie';
import CreatCategorie from './pages/CreatCategorie';
import CreatBataillon from './pages/CreatBataillon';
import ImportPersonnel from './pages/ImportPersonnel';
import Doublonspersonnels from './pages/doublonspersonnels';

import CreatBrigade from './pages/CreatBrigade';
import Personnel from './pages/Personnel';
import PersonnelsRetraite from './pages/PersonnelsRetraite';
import PersonnelsMilitaireRetraite from './pages/PersonnelsMilitaireRetraite';

import CreatPersonnel from './pages/CreatPersonnel';
import FichePersonnel from './pages/FichePersonnel';
import EditPersonnel from './pages/EditPersonnel';
import AddMinistreSuccessifs from './pages/AddMinistreSuccessifs';
import EditMinistreSuccessifs from './pages/EditMinistreSuccessifs';
import AddEtatMajorSuccessifs from './pages/AddEtatMajorSuccessifs';
import ListEtatMajorSuccessifs from './pages/ListEtatMajorSuccessifs';
import MinistreSuccessifsList from './pages/MinistreSuccessifsList';

import EditEtatMajorSuccessifs from './pages/EditEtatMajorSuccessifs';
import Etsouservice from './pages/Etsouservice';
import Bataillon from './pages/Bataillon';
import Compagnie from './pages/Compagnie';
import Brigade from './pages/Brigade';
import EditBrigade from './pages/EditBrigade';
import EditBataillon from './pages/EditBataillon';
import EffectifBrigade from './pages/EffectifBrigade';
import CreatEtsouservice from './pages/CreatEtsouservice';
import CreatCompagnie from './pages/CreatCompagnie';
import Grade from './pages/Grade';
import EditGrade from './pages/EditGrade';
import EditEtsouservice from './pages/EditEtsouservice';
import ModifierCompagnie from './pages/ModifierCompagnie';
import CreatGrade from './pages/CreatGrade';
import Contact from './pages/Contact';
import Recaptotalbrca from './pages/Recaptotalbrca';
import Decoration from './pages/Decoration';
import Dashboard from './pages/Dashboard';
import ListZonededefense from './pages/ListZonededefense';
import AddZonededefense from './pages/AddZonededefense';
import EditZonededefense from './pages/EditZonededefense';
import Navbar from './components/Navbar'; // Chemin correct vers Navbar

import MadagascarMap from './pages/MadagascarMap';
import ProtectedRoute from './helpers/ProtectedRoute';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="pb-5 pt-4 mt-5">
      <ToastContainer position="top-center" autoClose={5000} />
      <Navbar />
      <Routes>
        <Route path="/" exact element={<Dcca />} />
        {/* <Route path="/" exact element={<Pageaccueil />} /> */}
        <Route path="/etatmajor" exact element={<PageEtatMajor />} />
        <Route path="/accueildcca" exact element={<Accueildcca />} />
        <Route path="/dcca" exact element={<Dcca />} />
        <Route path="/login" exact element={<Login />} />
        <Route path="/post/:id" exact element={<Post />} />
        <Route path="/personnel/:id" exact element={<FichePersonnel />} />
        <Route path="*" exact element={<PageNotFound />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/creatpost" exact element={<CreactPost />} />
          <Route path="/listusers" exact element={<Users />} />
          <Route path="/createdusers" exact element={<CreatUsers />} />
          <Route path="/auth/edit/:id" exact element={<EditUser />} />
          <Route path="/directeurs/edit/:id" exact element={<EditDirecteur />} />
          <Route path="/decoration" exact element={<Decoration />} />
          <Route path="/brigade" exact element={<Brigade />} />
          <Route path="/Recaptotalbrca" exact element={<Recaptotalbrca />} />
          <Route path="/compagnie" exact element={<Compagnie />} />
          <Route path="/bataillon" exact element={<Bataillon />} />
          <Route path="/addministresuccessifs" exact element={<AddMinistreSuccessifs />} />
          <Route path="/ministresuccessifs/edit/:id/x" exact element={<EditMinistreSuccessifs />} />
          <Route path="/addchefetatmajor" exact element={<AddEtatMajorSuccessifs />} />
          <Route path="/etatmajoruccessifs" exact element={<ListEtatMajorSuccessifs />} />
          <Route path="/listministresuccessifs" exact element={<MinistreSuccessifsList />} />
          <Route path="/directeurs/" exact element={<Directeur />} />
          <Route path="/creatdirecteur/" exact element={<CreatDirecteur />} />

          <Route path="/editetatmajor/:id" exact element={<EditEtatMajorSuccessifs />} />
          <Route path="/statistics" exact element={<Dashboard />} />
          <Route path="/books" exact element={<Books />} />
          <Route path="/creatbooks" exact element={<CreatBooks />} />
          <Route path="/creatdecoration" exact element={<CreatDecoration />} />
          <Route path="/listcategorie" exact element={<Categorie />} />
          <Route path="/createcategorie" exact element={<CreatCategorie />} />
          <Route path="/importpersonnel" exact element={<ImportPersonnel />} />
          <Route path="/doublonspersonnels" exact element={<Doublonspersonnels />} />
          <Route path="/personnel" exact element={<Personnel />} />
          <Route path="/listeboasss" exact element={<ListeBoaDss />} />
          <Route path="/personnel/edit/:id" exact element={<EditPersonnel />} />
          <Route path="/createpersonnel" exact element={<CreatPersonnel />} />
          <Route path="/etsouservice" exact element={<Etsouservice />} />
          <Route path="/grade" exact element={<Grade />} />
          <Route path="/grade/:id/edit" exact element={<EditGrade />} />
          <Route path="/etsouservice/edit/:id" exact element={<EditEtsouservice />} />
          <Route path="/creatgrade" exact element={<CreatGrade />} />
          <Route path="/createtsouservice" exact element={<CreatEtsouservice />} />
          <Route path="/statistics" exact element={<Statistics />} />
          <Route path="/statisticsbyorganique" exact element={<EffectifNouriOrganique />} />
          <Route path="/statisticsbyoperationnel" exact element={<EffectifNouriOperationnel />} />
          <Route path="/personnelscivilretraite" exact element={<PersonnelsRetraite />} />
          <Route path="/personnelsmilitaireretraite" exact element={<PersonnelsMilitaireRetraite />} />
          <Route path="/brigade/:id/effectifbrigade" exact element={<EffectifBrigade />} />
          <Route path="/brigade/edit/:id" exact element={<EditBrigade />} />
          <Route path="/bataillon/edit/:id" exact element={<EditBataillon />} />
          <Route path="/compagnie/:id/edit" exact element={<ModifierCompagnie />} />
          <Route path="/contact" exact element={<Contact />} />
          <Route path="/creatbataillon" exact element={<CreatBataillon />} />
          <Route path="/creatcompagnie" exact element={<CreatCompagnie />} />
          <Route path="/creatbrigade" exact element={<CreatBrigade />} />
          <Route path="/recherche" exact element={<SearchForm />} />
          <Route path="/cartebrigademadagascar" exact element={<MadagascarMap />} />
          <Route path="/zonededefenses" element={<ListZonededefense />} />
          <Route path="/zonededefenses/add" element={<AddZonededefense />} />
          <Route path="/zonededefenses/edit/:id" element={<EditZonededefense />} />
          <Route path="/perso" exact element={<SearchForm />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
